import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect }    from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Tooltip,
  OverlayTrigger,
  Checkbox,
  Radio
}                     from 'react-bootstrap';
import { withRouter, Link } from 'react-router';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import { createBrowserHistory } from "history";
import moment from 'moment';

import {
  Breadcrumb as BreadcrumbComponent
}                        from '../../../components';

import { getAddRole, saveAddRole } from '../../../redux/actions/siteActions';
import idx from 'idx';
import { get_permission_list } from "../../../redux/actions/subAdminActions";
import ACL_LIST from "../subAdmin/aclList";

const history = createBrowserHistory(); 
let isLoading = "false";
class AddRole extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props){
    super(props);
    this.state = {
      path: ['Home', 'Edit Role'], 
      links: ["home",'/edit-role'],
      site_title: "",
      meta_keywords: "",
      meta_description: "",
      analytics_tracking_code_head: "",
      analytics_tracking_code_body: "",
      show: false,
      alertMessage: '',
      msgType: '',
      acl_settings: [],
      permissionList: [],
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);

    this.handleInputChange = this.handleInputChange.bind(this);
  }

   handleInputChange = event => {
    let checkValue = event.target.value;
    let checkIndex = this.state.acl_settings.indexOf(checkValue);
    let tmpAclSetting = this.state.acl_settings;
    if (checkIndex >= 0) {
      tmpAclSetting.splice(checkIndex, 1);
    } else {
      tmpAclSetting.push(checkValue);
    }
    this.setState({ acl_settings: tmpAclSetting });
  };

  handleDismiss(){
  	this.setState({
  		show: false,
  		alertMessage: '',
  		msgType: '',
  	});
  }

  componentWillMount(){
    this.handPageChange();
  }

  handPageChange(){
  	isLoading = "true";
    if(this.props.match.params && this.props.match.params.userTypeID){
  	 this.props.getAddRole(this.props.match.params.userTypeID);
     this.props.get_permission_list(`permission/actions/${this.props.match.params.userTypeID}`);
    }
  }
  componentWillReceiveProps(nextProps){
  	if(this.props.apiDetail !== nextProps.apiDetail){
  		if(nextProps.apiDetail){
			if(nextProps.apiDetail.data){
				this.setState({
          userTypeID: nextProps.apiDetail.data.userTypeID,
          userTypeName: nextProps.apiDetail.data.userTypeName,
          userTypeLabel: nextProps.apiDetail.data.userTypeLabel,
          userTypeDesc: nextProps.apiDetail.data.userTypeDesc,
				});
			}
			isLoading = "false";
      window.scrollTo(0, 0);
		}
  	}

  	if(this.props.settingStatus !== nextProps.settingStatus){
  		if(nextProps.settingStatus){
			this.setState({
		  		show: true,
		  		alertMessage: nextProps.settingStatus.message,
		  		msgType: 'success',
		  	});

			this.handPageChange();
		}
  	}

  	if(this.props.error !== nextProps.error){
  		if(nextProps.error){
  			this.setState({
  		  		show: true,
  		  		alertMessage: nextProps.error.message,
  		  		msgType: 'danger',
  		  	});

  			this.handPageChange();
  		}
  	}
    if (nextProps.permissionList !== this.props.permissionList) {
      this.setState({
        permissionList: nextProps.permissionList.action_permission,
        acl_settings: nextProps.permissionList.acl_permission,
        loading: false
      });
    }
  }

  handleChange = (e) => {
  	if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
  	this.setState({[e.target.name] : e.target.value })
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const constData = {
      userTypeID: (this.state.userTypeID) ? this.state.userTypeID : "",
      userTypeName: (this.state.userTypeName) ? this.state.userTypeName : "",
      userTypeLabel: (this.state.userTypeLabel) ? this.state.userTypeLabel : "",
      userTypeDesc: (this.state.userTypeDesc) ? this.state.userTypeDesc : "",
      permissions: this.state.acl_settings.join(),
    }
    isLoading = "true";
    this.props.saveAddRole(constData, 'user-role/edit');
  }

  checkAclSetting(aKey){
    return (this.state.acl_settings.indexOf(aKey) >= 0); // || aKey.indexOf('LIST_') >= 0
  }

  checkReadOnly(aKey){
    return false;
  }

  renderAlert() {
    if (this.state.msgType && this.state.message) {
      let msgClass =
        this.state.msgType == "error"
          ? "alert alert-danger"
          : "alert alert-" + this.state.msgType;
      return (
        <div className={msgClass}>
          <strong>{this.state.msgType.toUpperCase()} :</strong>{" "}
          {this.state.message}
        </div>
      );
    }
  }

  render() {
  let aclGroup;
    const {permissionList} = this.state;
    aclGroup = permissionList.map((agval, agindex) => (
      <div key={'panel'+agindex} className="panel panel-default">
        <div className="panel-heading" role="tab" id="headingOne">
          <h4 className="panel-title">
          <a role="button" data-toggle="collapse" data-parent="#accordion" href={'#collapse'+agindex} aria-expanded="true" aria-controls={'collapse'+agindex}>
            {agval.aLabel}
          </a>
        </h4>
        </div>
        <div id={'collapse'+agindex} className="panel-collapse collapse in" role="tabpanel" aria-labelledby={'heading'+agindex}>
          <div className="panel-body">
            {agval.aList.map((fval, findex) => (
                <Row key={'prow'+findex} className="aclRow">
                  <Col md={4} xs={12}><strong>{fval.aKey}</strong></Col>
                  <Col md={6} xs={12}>{fval.aDesc}</Col>
                  <Col md={2} xs={12}><Checkbox
                  inline
                  name="acl_settings"
                  onChange={this.handleInputChange}
                  key={fval.aKey+''+findex}
                  value={fval.aKey}
                  disabled={this.checkReadOnly(fval.aKey)}
                  defaultChecked={this.checkAclSetting(fval.aKey)}
                  >
                </Checkbox></Col>
                </Row>
              ))}
          </div>
        </div>
      </div>)); 
  return (
    <div className="col-lg-12 add-sub-admin">
    {isLoading == "true" ? (
      <div className="loader">
        <p className="loading-message">
          <i>Loading...</i>
        </p>
        <div className="spinner">
          <div className="dot1" />
          <div className="dot2" />
        </div>
      </div>
    ) : (
      ""
    )}
    <div className="row">
      <div className="col-xs-12">
         <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
      </div>
    </div>
    <form>
      <div className="panel">
          <header className="panel-heading">Edit Role</header>
          <div className="panel-body">
          {this.state.show && this.state.alertMessage !=='' &&  
          	<Row>      
              <Col md={12} xs={12}>
                <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                  <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                </Alert>
              </Col>
            </Row>
          }
          <Row>
	          <Col md={6} xs={6}>
	          	<FormGroup>
		            <ControlLabel>User Type Name:</ControlLabel>
		            <FormControl
		              type="text"
		              placeholder="User Type Name"
		              value={this.state.userTypeName}
		              name="userTypeName"
		              onChange={this.handleChange}
                  disabled={true}
		            />
	            </FormGroup>
	          </Col>
	          <Col md={6} xs={6}>
	          	<FormGroup>
		            <ControlLabel>User Type Label:</ControlLabel>
		            <FormControl
		              type="text"
		              placeholder="User Type Label"
		              value={this.state.userTypeLabel}
		              name="userTypeLabel"
		              onChange={this.handleChange}
		            />
	            </FormGroup>
	          </Col>
	          <Col md={6} xs={6}>
	          	<FormGroup>
		            <ControlLabel>User Type Description:</ControlLabel>
		            <FormControl
		              type="text"
		              placeholder="User Type Description"
		              value={this.state.userTypeDesc}
		              name="userTypeDesc"
		              onChange={this.handleChange}
		            />
	            </FormGroup>
	          </Col>
          </Row>
          </div>
      </div>
      <div className="panel">
          <header className="panel-heading">ACL Managements</header>
          <div className="panel-body">
            <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <Row>
                <Col md={12} xs={12}>
                  <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
                    {aclGroup}
                  </div>
                </Col>

              </Row>
              <Row><hr/></Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button bsStyle="default" className="pull-right" onClick={() => this.context.router.history.push("/role-list")}>Cancel</Button>
                  <Button bsStyle="success" className="pull-right" onClick={this.handleSubmit}>Save</Button>
                </Col>
              </Row>
            </div>
          </div>
        </div>
    </form>
    </div>
  )
  }
}

const mapStateToProps = (state,ownProps) => {
    return {
      error: state.siteReducer.error,
      apiDetail:  state.siteReducer.apiDetail,
      settingStatus:  state.siteReducer.settingStatus,
      permissionList: state.subAdminReducer.permissionList,
    };
};
export default compose(
  withRouter, 
  connect(mapStateToProps, {getAddRole, saveAddRole, get_permission_list})
)(AddRole);



// WEBPACK FOOTER //
// ./src/app/views/admin/role/EditRole.js